<template>
  <div id="app">
    <header>
      <div class="burger-menu" @click="toggleMenu">
        <span></span>
        <span></span>
        <span></span>
      </div>
      <nav class="desktop-nav" v-if="!menuVisible">
        <router-link to="/">Home</router-link>
        <router-link to="/qr-scanner">QR Scanner</router-link>
        <router-link to="/checklist">Checkliste</router-link>
        <router-link to="/branches">Unsere Zweige</router-link> 
      </nav>
      <nav class="mobile-nav" v-if="menuVisible">
        <router-link to="/" @click="closeMenu">Home</router-link>
        <router-link to="/qr-scanner" @click="closeMenu">QR Scanner</router-link>
        <router-link to="/checklist" @click="closeMenu">Tour</router-link>
        <router-link to="/branches" @click="closeMenu">Unsere Zweige</router-link>
      </nav>
    </header>
    <main>
      <router-view />
    </main>
    <footer>
      © BHAK Liezen 2025 | 
      <a href="https://hak-liezen.at/?view=article&id=46&catid=2" target="_blank" style="color: #f0f0f0; text-decoration: underline;">Impressum</a>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      menuVisible: false,
    };
  },
  methods: {
    toggleMenu() {
      this.menuVisible = !this.menuVisible;
    },
    closeMenu() {
      this.menuVisible = false;
    },
  },
};
</script>

<style scoped>
header {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  z-index: 10;
}

.burger-menu {
  display: flex;
  flex-direction: column;
  cursor: pointer;
  z-index: 15;
}

.burger-menu span {
  height: 4px;
  width: 25px;
  background: #fff;
  margin: 3px 0;
}

.mobile-nav {
  display: flex;
  flex-direction: column;
  background: #2c3e50;
  position: absolute;
  top: 50px;
  width: 100%;
  z-index: 10;
}

.mobile-nav a {
  padding: 15px;
  color: white;
  text-decoration: none;
}

.desktop-nav {
  display: flex;
  z-index: 5;
}

@media (max-width: 768px) {
  .desktop-nav {
    display: none;
  }
}
</style>
